/** @format */

import React, { useEffect, useState } from "react";

import Table1 from "./jadval1/Table";
import excel from "../../../../../icons/excel.png";
import ContentTop from "../../../components/ContentTop";
import { ExcelPrint } from "../../../../../components/functions/Print";

const VegetatsiyaSahifa = () => {
  const [date, setDate] = useState(new Date().toISOString().slice(0, 10));
  const [ldate, setLdate] = useState(date);

  useEffect(() => {
    setDate(ldate);
  }, [ldate]);

  return (
    <div>
      <ContentTop>
        <ul className='content-top-left in-menu'>
          <li>Vegetatsiya</li>

          
        </ul>

        <ul className='table-top-right d-flex align-items-center'>
          <li>
            <button
              className='btn p-0'
              onClick={() =>
                ExcelPrint("Vegetatsiya", "sheet 1", "controllable")
              }>
              <img src={excel} alt='404' />
            </button>
          </li>

          <input
            type='date'
            className='form-control form-control-sm'
            value={ldate}
            onChange={(e) => setLdate(e.target.value)}
          />
        </ul>
      </ContentTop>

      <div className='tabs-content table-box'>
        <div className='tabs-content-item active controlling-table'>
          <Table1 date={date} />
        </div>
      </div>
    </div>
  );
};

export default VegetatsiyaSahifa;
